export default __webpack_public_path__ + "static/media/leopold-senghor.1062f21f.jpg";